import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import {
  TextField,
  StyledButton,
  Loadable,
  SelectField
} from "components/support";

import IconButton from "material-ui-next/IconButton";

export default class BarcodesView extends Component {
  async handleBarcode(action, param, type, index) {
    const { sellable, viewModel, presenter } = this.props;
    await (action === "add"
      ? presenter.addBarcode(param, type)
      : presenter.deleteBarcode(param, index));
    sellable.barcodes = viewModel.currentBarcodes;
  }

  getBarcodeList(barCodes) {
    let barcodeList = [
      { value: "", label: "Selecione" },
      { value: "barcode", label: "Código de Barras" },
      { value: "gtin", label: "GTIN" },
      { value: "pack_barcode", label: "GTIN/Embalagem" }
    ];

    // Iterates over all barCodes and if finds a gtin or pack_barcode, removes them from the list
    barCodes.forEach(code => {
      const mode = code.mode || "create";
      if (
        mode === "create" &&
        (code.type === "gtin" || code.type === "pack_barcode")
      ) {
        barcodeList = barcodeList.filter(list => list.value !== code.type);
      }
    });

    return barcodeList;
  }

  handleLabel(type) {
    let label = "Código de Barras";

    if (type === "gtin") {
      label = "GTIN";
    } else if (type === "pack_barcode") {
      label = "GTIN/Embalagem";
    }

    return label;
  }

  render() {
    const { presenter, viewModel, errors } = this.props;
    const {
      loading,
      currentBarcodes,
      newBarcode,
      newBarcodeError,
      type
    } = viewModel;
    const { barcodeErrors } = errors;
    // const barcodeErrors = errors.barcodeErrors || [];
    // Double loading on screen - if Loadable is removed, deletion stops working

    return (
      <Loadable loading={loading}>
        <div>
          <div style={{ width: "100%", marginTop: "0.75em" }}>
            <Row top="xs">
              <Col xs={4}>
                <TextField
                  noMargin
                  fullWidth
                  value={newBarcode}
                  maxLength={14}
                  label="Novo código de barras"
                  errorText={newBarcodeError}
                  onChange={(_, value) =>
                    (viewModel.newBarcode = value.replace(/\D/g, ""))
                  }
                />
              </Col>
              <Col xs={4}>
                <SelectField
                  fullWidth
                  options={this.getBarcodeList(currentBarcodes)}
                  label="Tipo"
                  value={type}
                  onChange={(_, value) => (viewModel.type = value)}
                  selectfieldstyle={{ margin: 0 }}
                />
              </Col>
              <Col className="text-center full-height">
                <StyledButton
                  label="Adicionar"
                  style={{ marginTop: 26 }}
                  disabled={!type}
                  flat={true}
                  onClick={() => this.handleBarcode("add", newBarcode, type)}
                />
              </Col>
            </Row>
          </div>

          <Row>
            {currentBarcodes
              .filter(b => b.mode !== "delete")
              .map((barcode, i) => (
                <Col xs={12} lg={6} key={i}>
                  <div style={{ marginRight: "0.5em" }}>
                    <Row top="xs">
                      <Col xs>
                        <TextField
                          fullWidth
                          maxLength={14}
                          value={barcode.code}
                          label={this.handleLabel(barcode.type)}
                          onChange={(_, value) =>
                            presenter.editBarcode(
                              barcode.uuid,
                              value.replace(/\D/g, "")
                            )
                          }
                          errorText={barcodeErrors ? barcodeErrors[i] : ""}
                        />
                      </Col>
                      <Col>
                        <IconButton
                          style={{ paddingTop: "1.7em" }}
                          onTouchTap={() =>
                            this.handleBarcode("delete", barcode.uuid, type, i)
                          }
                        >
                          delete
                        </IconButton>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}
          </Row>
        </div>
      </Loadable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/barcodes/barcodes.view.js